export const DishItems = [
  {
    title: 'Santa Maria Grilled Beef',
    text: "The town of Santa Maria, California, is home to one of America's most delicious barbecue specialty. ",
    price: '7,50',
    img: 'https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fimages.media-allrecipes.com%2Fuserphotos%2F9368157.jpg&q=60&c=sc&orient=true&poi=auto&h=512',
  },
  {
    title: 'Oxtails with Gravy',
    text: "This oxtail recipe is an ancient recipe, and it's a soul food blast from the past. ",
    price: '8,50',
    img: 'https://www.allrecipes.com/thmb/yA4dS0qQhbOgUftZ2BJmjsPXPL0=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/89612-oxtails-with-gravy-ddmfs-4X3-1389-a7599c94be15437ea1ef156669f80f6e.jpg',
  },
  {
    title: 'Broccoli and Chicken Stir-Fry',
    text: 'A chicken and broccoli recipe. Serve with rice. ',
    price: '5,75',
    img: 'https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fimages.media-allrecipes.com%2Fuserphotos%2F9354058.jpg&q=60&c=sc&orient=true&poi=auto&h=512',
  },
  {
    title: "Bob's Stuffed Banana Peppers",
    text: 'Banana peppers are filled with an Italian sausage mixture and baked in a delicious tomato sauce. ',
    price: '6,25',
    img: 'https://www.allrecipes.com/thmb/WU_Fzdw29Gjl6armNyyl5SAkxFQ=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/105546-9d6a9f756d1a4189b87e9a06973edc76.jpg',
  },
  {
    title: 'Chicken with Caper Sauce',
    text: 'A rich lemon sauce for chicken makes this dish perfect for a special meal.',
    price: '4,25',
    img: 'https://www.allrecipes.com/thmb/nANH1SL1edvuLZs5vxylwpOfctI=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/132703-chicken-with-lemon-caper-sauce-mfs-4x3-162--68f7d16c33894f53a491c1876f1d5f97.jpg',
  },
  {
    title: 'Stuffing Meatloaf',
    text: 'This meatloaf with stuffing mix is easy to make for a super savory meatloaf!',
    price: '9,75',
    img: 'https://www.allrecipes.com/thmb/gaH69h_fM3GOTI9RCulmPsfRQxI=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/2806358-stuffing-meatloaf-Christina-4x3-1-2cbaae87ca60460f9763e1f784267901.jpg',
  },
  {
    title: 'Artichoke Chicken Casserole',
    text: 'This dish is great over orzo pasta with steamed broccoli or asparagus on the side. ',
    price: '5,50',
    img: 'https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fimages.media-allrecipes.com%2Fuserphotos%2F8919677.jpg&q=60&c=sc&orient=true&poi=auto&h=512',
  },
  {
    title: 'Loaded Chicken Carbonara',
    text: 'Easy and delicious weeknight dinner. ',
    price: '3,50',
    img: 'https://www.allrecipes.com/thmb/LKDilstCkVnoYAI09LKtDUNybZg=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/8108479-33b654c2d27a47edac4e5664f9aaa5e9.jpg',
  },
  {
    title: 'Dry Brine Turkey',
    text: 'Dry brining is the easiest way to get a moist and flavorful turkey on the table. ',
    price: '6,75',
    img: 'https://www.allrecipes.com/thmb/MuaTI6L0Kh0a0yO1e9C1pDq4eWg=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/2825192-d3fa371de1474d1aa70190cdc80bc71c.jpg',
  },
  {
    title: 'Prime Rib Roast and Gravy',
    text: 'Juicy, tender prime rib roast and delicious gravy. ',
    price: '9,75',
    img: 'https://www.allrecipes.com/thmb/q7wrbtBRvNe30ZBWaikqr6mihT8=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/9437476-8e98f53a90574f1182aaeb549f2d4744.jpg',
  },
];
